// Shared constants for the practice schema editor. Mirrors
// server/src/utils/leadSchemaValidation.js — client-side checks here are a UX convenience
// (fail fast, show inline errors) only. The server re-validates everything on submit
// regardless, so these two files must never be allowed to silently drift out of sync.

export const FIELD_TYPES = ["string", "integer", "boolean", "date", "enum"];

export const PII_SENSITIVITY_LEVELS = ["high", "needs_review", "none"];

export const FIELD_NAME_PATTERN = /^[a-z][a-z0-9_]{0,62}$/;

export const RESERVED_FIELD_NAMES = new Set(
  [
    "Id",
    "PracticeId",
    "ProviderId",
    "ProviderName",
    "ProviderFacilityName",
    "PatientFullName",
    "PatientContactNumber",
    "PatientInsuranceProvider",
    "CallerFirstName",
    "CallerLastName",
    "CallerPhoneNumber",
    "CallerInformation",
    "SchemaVersionId",
    "Status",
    "DoNotCall",
    "SendForCall",
    "CallLogId",
    "CallSummary",
    "Transcript",
    "TotalCallAttempts",
    "CallReceived",
    "MissedCalls",
    "LastCallDuration",
    "AIBotAnaylsisStatus",
    "CreateDateTime",
    "UpdateDateTime",
    "record_facts",
    "detected_answering_machine",
  ].map((name) => name.toLowerCase()),
);

export const isReservedFieldName = (name) =>
  typeof name === "string" && RESERVED_FIELD_NAMES.has(name.toLowerCase());
